import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import InputMask from 'react-input-mask';

import { Icon } from '../Icon/Icon';

interface Props {
  id: string;
  label: string;
  type: string;
  placeholder: string;
  onChange: (value: string) => void;
  value: string;
  className?: string;
  error?: string | boolean;
  showErrorOutLine?: boolean; // Case where we need the ability to show error outline if the input is 1 of 2 inputs
  isReadonly?: boolean;
}

enum IRD_MASK {
  NINE_DIGIT = '999-999-999',
  EIGHT_DIGIT = '99-999-9999', // Extra character at the end but this is where the mask is swapped to the nine digit mask
}

export const IrdNumberInput = (props: Props) => {
  const {
    id,
    label,
    onChange,
    value,
    className,
    error,
    placeholder,
    showErrorOutLine,
    isReadonly,
  } = props;

  const [mask, setMask] = useState<IRD_MASK>(value.length === 9 ? IRD_MASK.NINE_DIGIT : IRD_MASK.EIGHT_DIGIT);

  useEffect(() => {
    if (value.length === 8) {
      if (mask !== IRD_MASK.EIGHT_DIGIT) {
        setMask(IRD_MASK.EIGHT_DIGIT);
      }
    } else if (value.length === 9) {
      if (mask !== IRD_MASK.NINE_DIGIT) {
        setMask(IRD_MASK.NINE_DIGIT);
      }
    }
  }, [setMask, mask, value]);

  return (
    <div
      className={classNames('TextInput', className, { hasError: (!!error || showErrorOutLine), isDisabled: isReadonly })}
    >
      <label htmlFor={id}>
        <span className="TextInput-label">{label}</span>

        <InputMask
          type="tel"
          mask={mask}
          maskChar=" "
          value={value || ''}
          onChange={(e) => {
            const val = e.target.value;
            // Clean out any formatting characters before calling onChange
            onChange(val.replace(/[-, _]/g, ''));
          }}
          id={id}
          placeholder={placeholder}
        />

        {/* Error message */}
        {error && (
          <span className="TextInput-error">
            <Icon name="ic-exclamation" />{error}
          </span>
        )}
      </label>
    </div>
  );
};
